import type { Endpoint } from '../../core/services/apiClient.types';

export enum PopupBannerQueryKeys {
  CURRENT = 'popupBannerCurrent',
}

/**
 * Pop-up banner endpoint (Experience API / BFF, base `VITE_EXPERIENCE_API_BASE_URL`).
 *
 * `siteCode` is the only targeting input the client sends; country, offer, job title and identity
 * are all resolved server-side. Both values are embedded in the URL so the React Query key
 * (`[queryKey, url]`) changes on site/locale change and refetches automatically.
 *
 * The path appears here and nowhere else — it is contested as OQ-4 (`/v1.0/popup-banner` vs
 * `/v1.0/banner`) and settling it should touch one line.
 */
export const POPUP_BANNER_ROUTES = {
  CURRENT: (baseUrl: string, siteCode: string, locale: string): Endpoint => ({
    url: `${baseUrl}/v1.0/popup-banner?siteCode=${encodeURIComponent(
      siteCode,
    )}&locale=${encodeURIComponent(locale)}`,
    queryKey: PopupBannerQueryKeys.CURRENT,
  }),
} as const;
